/**
 * One instance for every [use case + lookAndFeel] combination
 * @constructor
 */
abstract class LookAndFeel {
    mode: string;

    constructor(mode: string) {
        this.mode = mode;
    }

    abstract createButton(element, controller);

    abstract createLabel(element, controller);

    abstract createRadioGroup(radioGroupName, radioElements, radioLabels, controller);

    abstract createCheckboxGroup(checkboxGroupName, checkboxElements, checkboxLabels, controller);

    abstract createTextbox(identifier: string, container: JQuery, controller: Controller);

    abstract createSelectionHybrid(identifier: string, element, controller);

    abstract createTabGroup(identifier: string, container: JQuery, controller: Controller, widgetFactory: WidgetFactory);

    abstract createPanel(identifier: string, contents: string, container: JQuery, controller: Controller, widgetFactory: WidgetFactory, defaultAction: Action);
   // abstract createSlider();

    abstract createListbox(identifier: string, container: JQuery, controller: Controller);
}